const state = {
  id: window.localStorage.getItem('USER_ID') || 0,
  first_name: '',
  last_name: '',
  email: '',
  country: '',
  city: '',
  avatar: '',
  isLogin: false,
  token: window.localStorage.getItem('TOKEN') || ''
}
const actions = {}
const mutations = {
  USER_INFO(state, payload) {
    state.id = payload.id
    state.first_name = payload.first_name
    state.last_name = payload.last_name
    state.email = payload.email
    state.country = payload.country
    state.city = payload.city
    state.avatar = payload.avatar
    state.isLogin = payload.isLogin
    state.token = payload.token
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
